<template lang="html">
  <div class="">
    <table width="100%">
      <thead>
        <tr>
          <th>{{$local_storage.get('razon')}} - {{$local_storage.get('rfc')}}</th>
          <th></th>
          <th></th>
          <th style="text-align:right">Fecha de Consulta: {{new Date().toLocaleDateString('es-mx', { weekday:'long', day:'numeric', month:'long', year:'numeric' })}}</th>
        </tr>
        <tr>
          <th colspan="4"><center>Servicio de consulta de movimientos en el SCCCyG / Estado de Cuenta Global / SoluciónA31</center></th>
        </tr>
      </thead>
    </table>
    <br>
    <table width="100%">
      <thead>
        <tr>
          <td width="25%"></td>
          <td width="25%">Fecha de aplicación de Cargos: &zwnj;{{(parametros.fecha_pago)}}&zwnj;</td>
          <td width="25%">Fecha de aplicación de Abonos: &zwnj;{{parametros.fecha_validacion}}&zwnj;</td>
          <td width="25%"></td>
        </tr>
      </thead>
    </table>
    <br>
    <table width="100%">
      <thead>
        <tr v-if="parametros.titulo_fraccion != undefined && parametros.titulo_fraccion != ''">
          <th colspan="5"><center>Estado de cuenta de la fracción: {{parametros.titulo_fraccion}}</center></th>
        </tr>
        <tr>
          <td colspan="5">
            Estado de cuenta del inventario inicial
          </td>
        </tr>
        <tr>
          <td class="fondo_gris" colspan="5">
            Cargos
          </td>
        </tr>
        <tr>
          <td width="50%">Detalle Cargos</td>
          <td class="numbers">Valor Comercial</td>
          <td class="numbers">Crédito IVA</td>
          <td class="numbers">Crédito IEPS</td>
          <td class="numbers">Crédito Total</td>
        </tr>
        <tr>
            <td><a class="link" @click="abrir_inventario(parametros['id_inventario'])">+Inventario Inicial</a></td>
            <td class="numbers">{{to_currency(parametros['total_inventario_inicial'])}}</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
        </tr>
        <tr>
            <td>Total Cargos</td>
            <td class="numbers">{{to_currency(parametros['total_inventario_inicial'])}}</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
        </tr>
        <tr class="fondo_gris">
            <td colspan="5">Abonos</td>
        </tr>
        <tr>
            <td width="50%">Detalle de Abonos</td>
            <td class='numbers'>Valor Comercial</td>
            <td class='numbers'>Crédito IVA</td>
            <td class='numbers'>Crédito IEPS</td>
            <td class='numbers'>Crédito Total</td>
        </tr>
        <tr v-for="(value, key) in parametros['pendiente_inicial']">
          <td>
            <a class="link" @click="abrir_abono_inicial(value['clave'], parametros['abonos_usados'])">
              <span v-if="value['clave'] == 'A3'">
                -Regularizacion por vencimiento de plazo (A3)
              </span>
              <span v-else>
                -{{key}} ({{value['clave']}})
              </span>
            </a>
          </td>
          <td class='numbers'>{{to_currency(value['total'])}}</td>
          <td class='numbers'>$0</td>
          <td class='numbers'>$0</td>
          <td class='numbers'>$0</td>
        </tr>
        <tr>
            <td>Total Abonos</td>
            <td class='numbers'>{{to_currency(parametros['total_abonos'])}}</td>
            <td class='numbers'>$0</td>
            <td class='numbers'>$0</td>
            <td class='numbers'>$0</td>
        </tr>
        <tr>
            <td>Saldo pendiente de descargo (Crédito)</td>
            <td class="numbers">{{to_currency(parametros['saldo_pendiente'])}}</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
            <td class="numbers">$0</td>
        </tr>
        <tr><td colspan="5"><br></td></tr>
        <tr>
            <td colspan="5"><strong>Estado de cuenta Global de Créditos</strong></td>
        </tr>
        <tr class="fondo_gris">
            <td colspan="5">Cargos</td>
        </tr>
        <tr>
            <td width="50%">Detalle de Cargos</td>
            <td class="numbers">Valor Comercial</td>
            <td class="numbers">Crédito IVA</td>
            <td class="numbers">Crédito IEPS</td>
            <td class="numbers">Crédito Total</td>
        </tr>
        <tr v-for="x in parametros['cargos_detalles']">
          <td><a class='link' @click="abrir_cargo_usado(x['clave'], x['nombre'], parametros['pedimentos_usados_s'], parametros['pedimentos_usados_n'])">-{{ ucwords(x['nombre']) + " (" + x['clave'] + ")" }}</a></td>
          <td class='numbers'>{{to_currency(x['valor_comercial'])}}</td>
          <td class='numbers'>{{to_currency(x['importe_iva'])}}</td>
          <td class='numbers'>{{to_currency(x['importe_ieps'])}}</td>
          <td class='numbers'>{{to_currency(x['importe_iva'] + x['importe_ieps'])}}</td>
        </tr>
        <tr>
            <td>Total Cargos</td>
            <td class='numbers'>{{to_currency(parametros['totales_cargos']['valor_comercial'])}}</td>
            <td class='numbers'>{{to_currency(parametros['totales_cargos']['importe_iva'])}}</td>
            <td class='numbers'>{{to_currency(parametros['totales_cargos']['importe_ieps'])}}</td>
            <td class='numbers'>{{to_currency(parametros['totales_cargos']['importe_iva'] + parametros['totales_cargos']['importe_ieps'])}}</td>
        </tr>
        <tr class="fondo_gris">
            <td colspan="5">Abonos</td>
        </tr>
        <tr>
            <td width="50%">Detalle de Abonos</td>
            <td class="numbers">Valor Comercial</td>
            <td class="numbers">Crédito IVA</td>
            <td class="numbers">Crédito IEPS</td>
            <td class="numbers">Crédito Total</td>
        </tr>
        <tr v-for="(value, key) in parametros['total_abonos_detalles']">
          <td>
            <a class='link' @click="abrir_abono_usado(value['clave'], parametros['restante'])">
              <span v-if="value['clave'] == 'A3'">
                -Regularizacion por vencimiento de plazo (A3)
              </span>
              <span v-else>
                -{{key}} ({{value['clave']}})
              </span>
            </a>
          </td>
          <td class='numbers'>{{to_currency(value['total'])}}</td>
          <td class='numbers'>{{to_currency(value['iva'])}}</td>
          <td class='numbers'>{{to_currency(value['ieps'])}}</td>
          <td class='numbers'>{{to_currency(value['iva'] + value['ieps'])}}</td>
        </tr>
        <tr>
            <td>Total Abonos</td>
            <td class='numbers'>{{to_currency(parametros['abonos_total_detalles'])}}</td>
            <td class='numbers'>{{to_currency(parametros['total_abonos_iva'])}}</td>
            <td class='numbers'>{{to_currency(parametros['total_abonos_ieps'])}}</td>
            <td class='numbers'>{{to_currency(parametros['total_abonos_iva'] + parametros['total_abonos_ieps'])}}</td>
        </tr>
        <tr>
            <td>Saldo pendiente de descargo (Crédito)</td>
            <td class='numbers'>{{to_currency(parametros['totales_cargos']['valor_comercial'] - parametros['abonos_total_detalles'])}}</td>
            <td class='numbers'>{{to_currency( parametros['totales_cargos']['importe_iva'] - parametros['total_abonos_iva'] )}}</td>
            <td class='numbers'>{{to_currency( parametros['totales_cargos']['importe_ieps'] - parametros['total_abonos_ieps'] )}}</td>
            <td class='numbers'>{{to_currency( (parametros['totales_cargos']['importe_ieps'] - parametros['total_abonos_ieps']) + parametros['totales_cargos']['importe_iva'] - parametros['total_abonos_iva'])}}</td>
        </tr>
        <tr>
            <td><a class="link" @click="abrir_sobredescargo(parametros['detalle_sobredescargo'])">- Sobredescargo</a></td>
            <td class='numbers'>{{to_currency(parametros['sobredescargo'])}}</td>
            <td class='numbers'>$0</td>
            <td class='numbers'>$0</td>
            <td class='numbers'>$0</td>
        </tr>
      </thead>
    </table>

    <v-dialog v-model="modal" max-width="70%" >
      <v-card>
        <v-card-text>
          <v-card-title>

            <span class="titulo_modal_estado">{{modal_titulo}}</span><br>
          </v-card-title>
          <hr>
          <v-card-actions>
            <v-spacer></v-spacer>
            <exportar-excel :data="datafiltered" :name="'DetallesEstadoCuenta_' + modal_titulo + '.xlsx'" :exportFields="campos_excel">
                <v-btn dark small color="success" title="Exportar Registros" v-tippy @click="filtrar_data">
                    <v-icon dark>get_app</v-icon>Excel
                </v-btn>
            </exportar-excel>
          </v-card-actions>
          <v-client-table ref="vuetable" :data="data" :columns="columns" :options="options" class="elevation-2 pa-2" :key="modal_titulo">
            <template slot="noResults">
              <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
            </template>

            <template slot="fecha" slot-scope="props">
              <div v-if="props.row.fecha != null">
                {{ props.row.fecha.substring(0,10) }}
              </div>
              <div v-else>
                {{props.row.fecha}}
              </div>
            </template>
            <template slot="fecha_pago" slot-scope="props">
              <div v-if="props.row.fecha_pago != null">
                {{ props.row.fecha_pago.substring(0,10) }}
              </div>
              <div v-else>
                {{props.row.fecha_pago}}
              </div>
            </template>
            <template slot="fecha_pago_rectificacion" slot-scope="props">
              <div v-if="props.row.fecha_pago_rectificacion != null">
                {{ props.row.fecha_pago_rectificacion.substring(0,10) }}
              </div>
              <div v-else>
                {{props.row.fecha_pago_rectificacion}}
              </div>
            </template>
            <template slot="fecha_validacion" slot-scope="props">
              {{ props.row.fecha_validacion.substring(0,10) }}
            </template>
            <template slot="total" slot-scope="props">
              <div style="text-align:right;">
                {{ to_currency_decimal(props.row.total) }}
              </div>
            </template>
            <template slot="valor_comercial" slot-scope="props">
              <div style="text-align:right;">
                {{ to_currency_decimal(props.row.valor_comercial) }}
              </div>
            </template>
            <template slot="iva" slot-scope="props">
              <div style="text-align:right;">
                {{ to_currency_decimal(props.row.iva) }}
              </div>
            </template>
            <template slot="ieps" slot-scope="props">
              <div style="text-align:right;">
                {{ to_currency_decimal(props.row.ieps) }}
              </div>
            </template>
            <template slot="saldo" slot-scope="props">
              <div style="text-align:right;">
                {{ to_currency_decimal(props.row.saldo) }}
              </div>
            </template>

          </v-client-table>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  props: {
    parametros: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    datafiltered:[],
    modal: false,
    modal_titulo: "",
    data: [],
    campos_excel: {},
    options: {
      filterable: [],
      sortable: [],
      headings: {}
    },
    columns: []
  }),
  computed: {
  },
  methods: {
    to_currency: function(x) {
      let cr = 'USD';

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cr,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })

      return formatter.format(x);
    },
    to_currency_decimal: function(x) {
      let cr = 'USD';

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cr,
        minimumFractionDigits: 2,
      })

      return formatter.format(x);
    },
    get_totales_abonos: function(datos, tipo) {
      var total = 0;

      for (var x in datos) {
        if (tipo === 'iva') {
          total += datos[x]['iva'];
        } else if (tipo === 'ieps') {
          total += datos[x]['ieps'];
        } else {
          total += datos[x]['iva'] + datos[x]['ieps'];
        }
      }

      return total;
    },
    ucwords: function(x) {
      return x.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
      });
    },
    abrir_inventario: function(id) {
      this.data = [];
      this.options = {
        filterable: ['aduana', 'patente', 'pedimento', 'fraccion_arancelaria'],
        sortable: ['aduana', 'patente', 'pedimento', 'fecha_entrada', 'fraccion_arancelaria', 'valor_comercial'],
        headings: {
          'fecha_entrada': 'Fecha Entrada',
          'fraccion_arancelaria': 'Fracción Arancelaria',
          'valor_comercial': 'Valor Comercial'
        }
      };

      this.campos_excel = {
        'Aduana': 'aduana',
        'Patente': 'patente',
        'Pedimento': 'pedimento',
        'Fecha Entrada': 'fecha_entrada',
        'Fraccion': 'fraccion_arancelaria',
        'Valor Comercial': 'valor_comercial',
      };

      this.columns = ['aduana', 'patente', 'pedimento', 'fecha_entrada', 'fraccion_arancelaria', 'valor_comercial'];
      this.modal_titulo = "Inventario Incial";

      this.$root.$dialogLoader.show('Espere un momento por favor..');

      var url = this.$apiSA31 + "soluciona31/get_inventario_inicial/";
      var data = {
        'id': id,
        'rfc': this.$local_storage.get('rfc')
      }
      axios.post(url, data).then(response => {
        this.modal = true;
        this.data = response.data['detalles'];

      }).catch(error => {
        let mensaje;
        var titulo = "¡Operación no Permitida!";
        var tipo = "error";
        if (typeof error.response !== "undefined") {
          mensaje = error.response.data.mensaje;
        } else {
          mensaje = "Ocurrió un error reportalo con el administrador.";
        }
        this.$swal({
          type: tipo,
          title: titulo,
          text: mensaje,
          footer: ""
        });
      }).then(() => {
        this.$root.$dialogLoader.hide();
      });
    },
    abrir_abono_inicial: function(clave, parametros) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');

      this.data = [];
      this.options = {
        filterable: ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'],
        sortable: ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'],
        headings: {
          'fecha': 'Fecha Aplicación',
          'fecha_validacion': 'Fecha Validación',
          'total': 'Valor Comercial',
          'clave': 'Clave Destino'
        },
        orderBy: {
          column: 'fecha',
          ascending: false
        }
      };
      this.columns = ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'];

      this.campos_excel = {
        'Fecha Aplicación': 'fecha',
        'Fecha Validación': 'fecha_validacion',
        'Clave Destino': 'clave',
        'Folio': 'folio',
        'Valor Comercial': 'total',
      };

      this.modal_titulo = "Pedimentos con Clave " + clave;

      var filtrados = parametros.filter(x => x.clave == clave && x.total > 0);

      filtrados.forEach((item) => {
        var item_n = Vue.util.extend({}, item)

        var existe = this.data.filter(y => y.folio == item_n.folio);

        if (existe.length > 0) {
          existe[0].total += item_n.total;
        } else {
          this.data.push(item_n);
        }
      });

      this.modal = true;

      this.$root.$dialogLoader.hide();
    },
    abrir_cargo_usado: function(clave, titulo, ids, idn) {
      this.data = [];
      this.options = {
        filterable: ['fecha_pago', 'no_pedimento', 'clave_documento', 'fecha_pago_rectificacion', 'no_pedimento_rectificado'],
        sortable: ['fecha_pago', 'no_pedimento', 'clave_documento', 'fecha_pago_rectificacion', 'no_pedimento_rectificado', 'valor_comercial', 'iva', 'ieps'],
        headings: {
          'fecha_pago': 'Fecha de Pago Original',
          'no_pedimento': 'Número Pedimento',
          'clave_documento': 'Clave Documento',
          'fecha_pago_rectificacion': 'Fecha de Pago Rectificación',
          'no_pedimento_rectificado': 'Número de Pedimento Rectificado',
          'valor_comercial': 'Valor Comercial',
          'iva': 'Importe IVA',
          'ieps': 'Importe IEPS'
        }
      };
      this.columns = ['fecha_pago', 'no_pedimento', 'clave_documento', 'fecha_pago_rectificacion', 'no_pedimento_rectificado', 'valor_comercial', 'iva', 'ieps'];

      this.campos_excel = {
        'Fecha de Pago Original': 'fecha_pago',
        'Número Pedimento': 'no_pedimento',
        'Clave Documento': 'clave_documento',
        'Fecha de Pago Rectificación': 'fecha_pago_rectificacion',
        'Número de Pedimento Rectificado': 'no_pedimento_rectificado',
        'Valor Comercial': 'valor_comercial',
        'Importe IVA': 'iva',
        'Importe IEPS': 'ieps'
      };

      this.modal_titulo = titulo;

      this.$root.$dialogLoader.show('Espere un momento por favor..');

      var url = this.$apiSA31 + "soluciona31/reportes/get_cargos_usados/";

      var data = {
        'ids': ids,
        'idn': idn,
        'clave': clave
      }

      if(this.parametros['titulo_fraccion'] != undefined && this.parametros['titulo_fraccion'] != null && this.parametros['titulo_fraccion'] != "") {
        data['fraccion'] = this.parametros['titulo_fraccion'];
        data['identificador'] = this.parametros['pedimentos_usados_n'].length > 0 ? "N" : "S";
      }
      axios.post(url, data).then(response => {
        this.modal = true;
        this.data = response.data;

      }).catch(error => {
        let mensaje;
        var titulo = "¡Operación no Permitida!";
        var tipo = "error";
        if (typeof error.response !== "undefined") {
          mensaje = error.response.data.mensaje;
        } else {
          mensaje = "Ocurrió un error reportalo con el administrador.";
        }
        this.$swal({
          type: tipo,
          title: titulo,
          text: mensaje,
          footer: ""
        });
      }).then(() => {
        this.$root.$dialogLoader.hide();
      });
    },
    abrir_abono_usado: function(clave, parametros) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');

      this.data = [];
      this.options = {
        filterable: ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'],
        sortable: ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'],
        headings: {
          'fecha': 'Fecha Aplicación',
          'fecha_validacion': 'Fecha Validación',
          'total': 'Valor Comercial',
          'clave': 'Clave Destino'
        },
        orderBy: {
          column: 'fecha',
          ascending: false
        }
      };
      this.campos_excel = {
        'Fecha Aplicación': 'fecha',
        'Fecha Validación': 'fecha_validacion',
        'Clave Destino': 'clave',
        'Folio': 'folio',
        'Valor Comercial': 'total',
      };

      this.columns = ['fecha', 'fecha_validacion', 'clave', 'folio', 'total'];

      this.modal_titulo = "Pedimentos con Clave " + clave;

      var filtrados = parametros.filter(x => x.clave == clave && x.total > 0);

      filtrados.forEach((item) => {
        var item_n = Vue.util.extend({}, item)
        
        var existe = this.data.filter(y => y.folio == item_n.folio);
        if (existe.length > 0) {
          existe[0].total += item_n.total;
        } else {
          this.data.push(item_n);
        }
      });

      this.modal = true;

      this.$root.$dialogLoader.hide();
    },
    abrir_sobredescargo: function(parametros) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');

      this.data = [];
      this.options = {
        filterable: ['fraccion_arancelaria', 'identificador'],
        sortable: ['fraccion_arancelaria', 'identificador', 'saldo'],
        headings: {
          'fraccion_arancelaria': 'Fracción Arancelaria',
        }
      };
      this.columns = ['fraccion_arancelaria', 'identificador', 'saldo'];

      this.campos_excel = {
        'Fraccion Arancelaria': 'fraccion_arancelaria',
        'Identificador': 'identificador',
        'Saldo': 'saldo'
      };

      this.modal_titulo = "Sobredescargos por Fracción";

      this.data = parametros;
      this.modal = true;

      this.$root.$dialogLoader.hide();
    },
    filtrar_data: function(){
      if (this.$refs.vuetable != null) {
          this.datafiltered = this.$refs.vuetable.allFilteredData;
      } else {
          this.datafiltered = this.data;
      }
    }
  }
}
</script>

<style lang="css" scoped>
.fondo_gris {
  background-color: #E6E6E6;
}

.link {
  color: #0e4d78;
  cursor: pointer;
}

.titulo_modal_estado {
  font-weight: bold;
  font-size: 1.5rem;
}

.numbers{
  text-align: right;
}
</style>
